const images = {
  splashIcon: require("@assets/splash.png"),
  logoPVCB: require("@assets/images/logo/bitmap.png"),
  logoPVCB_bg_white: require("@assets/images/logo/bitmap_bg_white.png"),

  avatar_default: require("@assets/icon.png"),
  vietnam_round: require("@assets/images/logo/vietnam.png"),
  english_round: require("@assets/images/logo/english.png"),

  // CARD
  card_physical_register: require("@assets/icons/icon-png/card/card_physical_register.png"),

  // tour_guild
  start_guild_1: require("@assets/images/instruction/starttour1.jpg"),
  start_guild_2: require("@assets/images/instruction/starttour2.jpg"),
  start_guild_3: require("@assets/images/instruction/starttour3.jpg"),
  start_guild_4: require("@assets/images/instruction/starttour4.jpg"),

  // otp guild
  otp_guild_mobile: require("@assets/images/instruction/hdsd-otp-mobile.jpg"),
  otp_guild_web: require("@assets/images/instruction/hdsd-otp-web.jpg"),
  report_guide: require("@assets/images/instruction/hdsd-report-guide.jpg"),
  report_guide_mobile: require("@assets/images/instruction/hdsd-report-guide-mobile.jpg"),
  otp_guide: require("@assets/images/instruction/hdsd-otp-guide.jpg"),
  ratting_app: require("@assets/images/instruction/ratting-app.jpg"),

  // Popup
  popup_247: require("@assets/images/popup/popup-1.jpg"),
  popup_update: require("@assets/images/popup/thong-bao-nang-cap.jpg"),

  // Update PVConnect
  pv_connect_update: require("@assets/images/update/qr_update_pvconnect.jpg"),
  app_store_update: require("@assets/images/update/app_store.png"),
  play_store_update: require("@assets/images/update/play_store.png"),

};

export default images;
